import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import AppLayout from "../components/AppLayout";
import StationCard from "../components/StationCard";
import api from "../services/api";

export default function History() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get("/api/history?limit=50");
      setItems(res.data);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const clearAll = async () => {
    if (!window.confirm(t("history.confirmClear"))) return;
    try {
      await api.delete("/api/history");
      setItems([]);
    } catch { /* ignore */ }
  };

  return (
    <AppLayout
      title={t("history.title")}
      actions={
        items.length > 0 && (
          <button onClick={clearAll} className="text-sm bg-gray-100 hover:bg-red-100 hover:text-red-600 text-gray-700 px-3 py-2 rounded-md">
            {t("history.clear")}
          </button>
        )
      }
    >
      {loading ? (
        <p className="text-gray-500">{t("common.loading")}</p>
      ) : items.length === 0 ? (
        <p className="text-gray-500">{t("history.empty")}</p>
      ) : (
        <div className="grid gap-3">
          {items.map((s) => (
            <StationCard key={s.id} station={s} />
          ))}
        </div>
      )}
    </AppLayout>
  );
}
